<template>
  <iRow
    :class="`toolbar staging-toolbar`"
    wrap="nowrap"
    align="between"
    vertical-align="middle"
  >
    <iRow
      gap="small"
      vertical-align="middle"
      width="hug"
      wrap="nowrap"
    >
      <Logo :show-title="false" height="50px" width="40px" />
      <iColumn gap="none">
        <iHeading :wrap="false" font-size="large" variant="standard">
          {{ toolbarHeaderTitle }}
        </iHeading>
        <iText
          v-if="toolbarHeaderSubtitle"
          :wrap="false"
          font-size="small"
          variant="standard"
        >
          {{ toolbarHeaderSubtitle }}
        </iText>
      </iColumn>
    </iRow>
    <iDropdownMenu
      :items="parsedSecondaryNavData"
      :show-dropdown="showAvatarDropdown"
      @close="closeAvatarDropdown"
    >
      <template #trigger>
        <iColumn gap="extraSmall" vertical-align="middle">
          <iRow
            class="my-account-btn"
            gap="small"
            height="fill"
            vertical-align="middle"
            width="hug"
            wrap="nowrap"
            position="relative"
            :position-placements="{top: '3px'}"
            @click="toggleAvatarDropdown"
          >
            <iColumn vertical-align="middle">
              <AvatarImage :src="userData.avatar_url || ''" size="32px" />
            </iColumn>
          </iRow>
          <iSpace />
        </iColumn>
      </template>
    </iDropdownMenu>
  </iRow>
</template>

<script>
import Logo from "@/components/Logo.vue";
import { mapState } from "pinia";
import AvatarImage from "%/components/AvatarImage.vue";
import { useGeneralStore } from "%/stores/general-store";
import { filterMenuItems } from "@/helpers/capabilities-helper";
import { MAIN_NAV_SECONDARY } from "@/constants/nav-constants";
import { parseUrlVars } from "@/helpers/parseUrlVars";

export default {
  name: "CreateToolbar",
  components: { AvatarImage, Logo },
  props: {
    headerTitle: {
      type: String,
      default: "",
    },
    headerSubtitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showAvatarDropdown: false,
    };
  },
  computed: {
    ...mapState(useGeneralStore, [
      "userData",
    ]),
    parsedSecondaryNavData() {
      const filteredNavItems = filterMenuItems(MAIN_NAV_SECONDARY);
      return parseUrlVars(filteredNavItems, { "{org_id}": this.orgId, "{user_id}": this.userId });
    },
    toolbarHeaderTitle() {
      return this.headerTitle || "Create Dashboard";
    },
    toolbarHeaderSubtitle() {
      return this.headerSubtitle;
    },
  },
  methods: {
    toggleAvatarDropdown() {
      this.showAvatarDropdown = !this.showAvatarDropdown;
    },
    closeAvatarDropdown() {
      this.showAvatarDropdown = false;
    },
  },
  styleGuide: () => ({
    "toolbarBorder": { "color.border": "dark" },
    "paddingStandard": { "size.spacing": "standard" },
    "paddingSmall": { "size.spacing": "small" },
    "editBackgroundColor": { "color.background": "paper" },
    "backgroundColor": { "color.background": "dark" },
  }),
};
</script>

<style lang="scss" scoped>
.staging-toolbar {
  position: relative;
}

.staging-toolbar-center {
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}
</style>

<style lang="scss" scoped>
.toolbar {
  border-bottom: 1px solid v-bind("$getStyles.toolbarBorder") !important;
  padding-inline: v-bind("$getStyles.paddingStandard");
  padding-block: v-bind("$getStyles.paddingSmall");
  z-index: 2;
  background-color: v-bind("$getStyles.editBackgroundColor");
}

:deep(h1) {
  line-height: unset !important;
}

.clickable {
  cursor: pointer;
}

:deep(.i-button) {
  svg {
    position: relative;
  }
}
</style>
